const NotFound = () => {
  return (
    <div className='h-full w-full fixed flex flex-col items-center justify-center'>
      <div>
        <img src='/images/oge-logo.svg' alt='OGE' className='h-64 w-64' />
      </div>
      <p className='text-3xl text-dark-blue font-black'>
        The page you are looking for does not exists
      </p>
    </div>
  )
}

export default NotFound
